// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var message = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
  if (message.TAG === /* Ok */0) {
    var error = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "error"), null));
    if (error.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                message: message._0,
                error: error._0
              }
            };
    }
    var e = error._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".error" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = message._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".message" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var Decode = {
  t_decode: t_decode
};

function getErrorMessage(decoded) {
  var match = decoded.message;
  var match$1 = decoded.error;
  if (match !== undefined) {
    return match;
  } else if (match$1 !== undefined) {
    return match$1;
  } else {
    return ;
  }
}

function execute(response) {
  if (typeof response === "number") {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(response);
  }
  switch (response.TAG | 0) {
    case /* UnprocessedEntity */2 :
    case /* InternalServerError */6 :
        break;
    default:
      return ResponseHandler$Catalyst.DefaultErrorConverter.execute(response);
  }
  var decoded = t_decode(response._0);
  var errorMsg;
  errorMsg = decoded.TAG === /* Ok */0 ? getErrorMessage(decoded._0) : undefined;
  if (errorMsg !== undefined) {
    return /* DefaultError */{
            _0: {
              title: {
                TAG: /* UnprocessedEntity */1,
                _0: errorMsg
              },
              message: errorMsg
            }
          };
  } else {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(response);
  }
}

export {
  Decode ,
  getErrorMessage ,
  execute ,
  
}
/* ResponseHandler-Catalyst Not a pure module */
